import React from 'react';
import Moment from 'react-moment';

import { Dot } from '../Dot';
import { Status } from '../Status';
import { StatusService } from '../../services/status';

import styles from './index.css';

export class HistoryStatus extends React.Component {
    render() {
        return (
            <div className={styles.root}>
                <Dot className={styles.dot} color={StatusService.color(this.props.statusID)} />
                <Status includeID statusID={this.props.statusID} thirdParty={this.props.thirdParty} />
                <Moment className={styles.date} format="YYYY/MM/DD HH:mm:ss">{this.props.date}</Moment>
            </div>
        );
    }
}
